import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const planka = defineConnector({
  identifier: "planka",
  name: "Planka",
  tagLine: "Self-hosted kanban board for project management",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Get your Planka access token",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to your Planka instance and obtain an access token by posting credentials to `/api/access-tokens`.",
        },
        {
          kind: "url",
          label: "Server URL",
          required: true,
          placeholder: "https://planka.example.com",
          target: { kind: "configuration", field: "instanceUrl" },
          helperText: "The base URL of your Planka instance.",
        },
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => `${instanceUrl}/api/access-tokens`,
  },
});
